/* @flow weak */
import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Redirect from 'components/Redirect.jsx';
import * as React from 'react';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import UserAgent from 'lib/UserAgent';

import './styles/MergeDirectAddeePage.scss';

type Props = MergeDirectAddeePageQuery & {
  params: { token: string },
  error?: *,
};

export class MergeDirectAddeePage extends React.Component<Props> {
  render() {
    const { token } = this.props.params;
    const { user, error } = this.props;

    if (user) {
      return <Redirect to={`/classes?email_token=${token}`} />;
    }

    // If there's a 401 error, the user is logged out so we show the logged out flow
    if (error) {
      const userAgent = new UserAgent(window.navigator.userAgent);
      return (
        <AuthenticationView>
          <TitleHeader
            title="Have you used Remind before?"
            image={require('assets/images/book-phone.svg')}
            imageClassName="MergeDirectAddeePage-image"
          />
          <Button
            full
            className="MergeDirectAddeePage-merge"
            eventElementName="MergeDirectAddeePage-merge"
            to={`/log_in/?email_token=${token}`}>
            Yes, I have
          </Button>
          <Button
            full
            className="MergeDirectAddeePage-cancel"
            eventElementName="MergeDirectAddeePage-cancel"
            color="brand"
            level="secondary"
            to={`/confirm_email/${token}`}>
            No, I am new to Remind
          </Button>
          {userAgent.ios() ? (
            <Link
              className="MergeDirectAddeePage-app"
              weight="semibold"
              block
              href={`rmd://direct_addee/${token}`}>
              I already have the app
            </Link>
          ) : null}
        </AuthenticationView>
      );
    }

    return null;
  }
}

const withUser = graphql(
  gql`
    query MergeDirectAddeePage {
      user: me {
        id
        uuid
      }
    }
  `,
  {
    props: ({ data }) => data,
    options: { fetchPolicy: 'network-only', withProps: true },
  }
);

export default withUser(MergeDirectAddeePage);
